module.exports = __webpack_public_path__ + "img/paystar2.daa8391c.png";